import React from "react";
import PropTypes from "prop-types";
import { isZh } from "../utils/language";

export default function FolderInfoDialog({ folder, onClose }) {
  if (!folder) return null;

  const handleCopyLink = async () => {
    if (!folder) return;

    const link = buildFolderLink(folder);

    try {
      await navigator.clipboard.writeText(link);
      alert("Tautan disalin");
    } catch (err) {
      alert("Gagal menyalin");
    }
  };

  const handleShare = async () => {
    if (!folder) return;

    const link = buildFolderLink(folder);

    if (navigator.share) {
      try {
        await navigator.share({
          title: folder.name,
          url: link,
        });
      } catch (err) {
        console.error(err);
      }
    } else {
      await navigator.clipboard.writeText(link);
      alert("Tautan disalin");
    }
  };
  
  const buildFolderLink = (folder) => {
    return `${window.location.origin}/files?folder=${encodeURIComponent(folder.documentId)}`;
  };

  const name = isZh()
    ? folder.name_zh || folder.name
    : folder.name || folder.name_zh;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e)=>e.stopPropagation()}>
        <h3>{isZh() ? "資料夾資訊" : "Folder Properties"}</h3>

        <div className="info-group">
          <div><strong>{isZh() ? "名稱" : "Name"}:</strong> {name}</div>
          <div><strong>{isZh() ? "建立時間" : "Created"}:</strong> {folder.createdAt}</div>
          <div><strong>{isZh() ? "更新時間" : "Updated"}:</strong> {folder.updatedAt}</div>
        </div>

        <div className="dialog-actions">
          <button onClick={handleCopyLink} className="btn-secondary">
            <span>
            <img src="/icons/link-copy.png" alt={isZh() ? "复制链接" : "Copy Link"} style={{ width: "1.2rem", height: "1.2rem", paddingRight:"0.3rem" }} />
            {isZh() ? "复制链接" : "Copy Link"}
            </span>
          </button>
          <button onClick={handleShare} className="btn-secondary">
            <span className="menu-icon">
            <img src="/icons/link-share.png" alt={isZh() ? "分享" : "Share"} style={{ width: "1.2rem", height: "1.2rem", paddingRight:"0.3rem" }} />
            {isZh() ? "分享" : "Share"}
            </span>
          </button>
          <button onClick={onClose} className="btn-secondary">
            {isZh() ? "關閉" : "Close"}
          </button>
        </div>
      </div>
    </div>
  );
}

FolderInfoDialog.propTypes = {
  folder: PropTypes.object,
  onClose: PropTypes.func.isRequired,
};
